import { IPromise } from "angular";
import { IModalScope, IModalService } from "angular-ui-bootstrap";
import { IPlanningSession } from "../models/models";
import { INgRedux } from "@gtmhub/state-management";
import { PlanningSessionsActions } from "../redux/session-actions";
import { filterOpenedActiveAndFutureSessions, filterOpenedActiveAndFutureSessionsAndOneLevelChildren } from "../redux/session-selectors";
import { ISessionsStoreState } from "../redux/session-reducer";

const bindStateToThis = (state: ISessionsStoreState): Record<string, unknown> => {
  return {
    sessions: state.sessions.items,
  };
};

interface IGenericGoalSelectorScope extends IModalScope {
  selectSessionList(session: IPlanningSession): void;
  activeSessions: IPlanningSession[];
  selected: { screen: string };
}
export class PlanningSessionSelector {
  private sessions: IPlanningSession[];

  static $inject = ["$uibModal", "$ngRedux", "PlanningSessionsActions"];

  constructor(private $uibModal: IModalService, $ngRedux: INgRedux, actions: PlanningSessionsActions) {
    $ngRedux.connect(bindStateToThis)(this);
    $ngRedux.dispatch(actions.getSessionsIfMissing());
  }

  selectSession(options: { parentSessionId?: string } = {}): IPromise<IPlanningSession> {
    let activeSessions: IPlanningSession[];
    if (options.parentSessionId) {
      activeSessions = filterOpenedActiveAndFutureSessionsAndOneLevelChildren(this.sessions, options.parentSessionId);
    } else {
      activeSessions = filterOpenedActiveAndFutureSessions(this.sessions);
    }
    return this.$uibModal.open({
      templateUrl: require("../../goals/views/generic-goal-selector.jade"),
      windowClass: "medium",
      controller: [
        "$scope",
        function ($scope: IGenericGoalSelectorScope) {
          $scope.selected = {
            screen: "sessions",
          };

          $scope.activeSessions = activeSessions;

          $scope.selectSessionList = (session: IPlanningSession) => {
            $scope.$close(session);
          };
        },
      ],
    }).result;
  }
}
